module.exports = __webpack_public_path__ + "static/media/firstlithoniawomenshealth.79b13de7.jpg";